document.addEventListener('DOMContentLoaded', function() {
  
  function checkVariantSelection() {
    const variantSelects = document.querySelectorAll('select[name="id"], .product-form__input select, select.product-form__select');
    const addToCartButtons = document.querySelectorAll('button[name="add"], .product-form__submit, button[type="submit"]');
    
    let hasPlaceholder = false;
    
    variantSelects.forEach(function(select) {
      if (select.offsetParent !== null) { // Nur sichtbare Selects prüfen
        const selectedOption = select.options[select.selectedIndex];
        const selectedText = selectedOption?.text || '';
        
        // Prüfe ob ein Platzhalter ausgewählt ist
        if (selectedText.includes('Hier bitte') || selectedText.includes('– Hier')) {
          hasPlaceholder = true;
        }
      }
    });
    
    // Button deaktivieren wenn mindestens EIN Platzhalter ausgewählt ist
    addToCartButtons.forEach(function(button) {
      if (hasPlaceholder) {
        button.disabled = true;
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
      } else {
        button.disabled = false;
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
      }
    });
  }
  
  // Event Listener für alle Selects
  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'SELECT') {
      checkVariantSelection();
    }
  });
  
  // Initial check mit Verzögerung
  setTimeout(checkVariantSelection, 500);
});

